import { useNavigate } from "react-router-dom";

const PrivacyPage = () => {
  const navigate = useNavigate();

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 36, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 16, padding: "28px 28px" }}>
      <h2 style={{ fontFamily: "'Fredoka One', cursive", fontSize: 22, color: "#A855F7", marginBottom: 14 }}>{title}</h2>
      <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 15, lineHeight: 1.85, whiteSpace: "pre-line" }}>{children}</div>
    </div>
  );

  return (
    <main style={{ paddingTop: 90 }}>
      <div style={{ maxWidth: 800, margin: "0 auto", padding: "60px 5%" }}>
        <div style={{ marginBottom: 40 }}>
          <span style={{ color: "#A855F7", fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>Legal</span>
          <h1 style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(36px,5vw,56px)", marginTop: 8, marginBottom: 16 }}>
            Privacy <span style={{ color: "#A855F7" }}>Policy</span>
          </h1>
          <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 14 }}>Effective Date: [Insert Date] · Applies to all NovuliGames titles</p>
          <div style={{ height: 2, background: "linear-gradient(90deg, #A855F7, #3EAEFF, transparent)", marginTop: 24 }} />
        </div>

        <Section title="Introduction">
          {`Welcome to NovuliGames - an independent mobile game studio. This Privacy Policy covers all our Android applications available on the Google Play Store, including Color Clash and Wealth Empire: Idle Tycoon.

We are committed to protecting your privacy and ensuring transparency about how your information is managed. By using any NovuliGames app, you agree to the terms outlined in this Privacy Policy.`}
        </Section>

        <Section title="Information We Collect">
          {`Our games are designed to be simple, offline experiences and do not collect personally identifiable information directly from users.

However, our apps may use third-party services (such as advertising and analytics providers) that may collect certain information automatically, including:

• Device information (e.g., device model, operating system version)
• General usage data (e.g., interactions with ads)
• IP address (for approximate location and ad delivery)

This data is collected only by third-party services and is subject to their respective privacy policies.`}
        </Section>

        <Section title="How We Use Information">
          {`Since NovuliGames does not directly collect personal data, we do not use user information ourselves.

Any data collected by third-party services may be used to:

• Display relevant advertisements
• Improve ad performance and user experience
• Analyze app performance and stability
• Detect and prevent fraud or misuse`}
        </Section>

        <Section title="Third-Party Services">
          {`Our games may integrate the following third-party services:

• Google AdMob (for displaying advertisements)
• Google Play Services (for analytics, performance monitoring, and app functionality)

These services may collect and process data under their own privacy policies. We encourage users to review them:

Google Privacy Policy: https://policies.google.com/privacy

We do not control how these third parties collect or use your data.`}
        </Section>

        <Section title="Data Retention">
          {`NovuliGames does not store or retain any personal user data on its own servers.

Any data collected by third-party services is managed and retained according to their respective privacy policies.`}
        </Section>

        <Section title="Children's Privacy">
          {`Our games are suitable for users of all ages, including children.

We do not knowingly collect personal information from children under the age of 13. If you believe that a child has provided personal information through third-party services, please contact us so we can take appropriate action.

We encourage parents and guardians to supervise children's app usage.`}
        </Section>

        <Section title="Security">
          {`We value your trust and strive to use commercially acceptable means to protect your information.

While our apps do not collect or store personal data, we rely on trusted third-party services that implement industry-standard security measures to safeguard any data they process.`}
        </Section>

        <Section title="Changes to This Privacy Policy">
          {`We may update this Privacy Policy from time to time to reflect changes in our practices or for legal and regulatory reasons.

Any updates will be posted within the app or on the app's listing page. Users are advised to review this policy periodically for any changes.`}
        </Section>

        <Section title="Contact Information">
          {`If you have any questions or concerns about this Privacy Policy, please contact us:

Email: connecter072@gmail.com`}
        </Section>

        <div style={{ textAlign: "center", marginTop: 48, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button className="btn-primary" onClick={() => navigate("/")} style={{ fontSize: 15, padding: "14px 32px" }}>
            ← Back to Home
          </button>
          <button className="btn-secondary" onClick={() => navigate("/games")} style={{ fontSize: 15, padding: "14px 32px" }}>
            Browse Games
          </button>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPage;